import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { UserService } from '../_services/user.service';

@Component({
  selector: 'app-alta-usuario',
  templateUrl: './alta-usuario.component.html',
  styleUrls: ['./alta-usuario.component.scss']
})
export class AltaUsuarioComponent implements OnInit {

  formAltaUsuario!: FormGroup;
  validaciones!: Boolean;
  formEnviado!: Boolean;
  listaRoles: any = [];
  error!: boolean;
  mensajeError!: string;
  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private router: Router) { }

  get formulario(): { [key: string]: AbstractControl } {
    return this.formAltaUsuario.controls;
  }
  ngOnInit(): void {
    this.getRoles();
    this.formAltaUsuario = this.formBuilder.group(
      {
        nombreUsuario: [null, Validators.required],
        cargo: [null, Validators.required],
        nombre: [null, Validators.required],
        apellido: [null, Validators.required],
        idTipoDocumento: ['1', Validators.required],
        numeroDocumento: [
          null,
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[0-9]{6,8}$')
            ])
        ],
        cuil: [null, Validators.required],
        sexo: [null, Validators.required],
        email: [null, [Validators.required, Validators.email]],
        password: [null, Validators.required],
        rol: [null, Validators.required],
        legajo: [null, Validators.required],
        institucion: [null, Validators.required],

      }
    );
  }

  onSubmit() {
    this.formEnviado = true;
    this.validaciones = true;
    if (this.formAltaUsuario.valid) {
      this.altaUsuario();
    }
  }

  getRoles() {
    this.userService.getRoles().subscribe(result => {
      this.listaRoles = result;
    }, (error) => {

    });
  }

  altaUsuario() {
    this.error = false;
    let formObj = this.formAltaUsuario.getRawValue();
    let body: any = {};
    body.documento = {};
    body.documento.tipoDocumento = {};
    body.documento.tipoDocumento.idTipoDocumento = parseInt(formObj.idTipoDocumento);
    body.documento.tipoDocumento.abreviatura = null;
    body.documento.tipoDocumento.nombre = null;
    body.documento.numeroDocumento = formObj.numeroDocumento;
    body.username = formObj.nombreUsuario;
    body.nombre = formObj.nombre;
    body.apellido = formObj.apellido;
    body.legajo = formObj.legajo;
    body.email = formObj.email;
    body.cuil = formObj.cuil;
    body.password = formObj.password;
    body.sexo = formObj.sexo;
    body.cargo = formObj.cargo;
    body.institucion = formObj.institucion;
    body.roles = [];
    let rolSeleccionado: any;
    this.listaRoles.forEach((el: any) => {
      if (el.codigo === formObj.rol) {
        rolSeleccionado = el;
      }
    });
    let rol: any = {};
    rol.codigo = rolSeleccionado.codigo;
    rol.idRol = rolSeleccionado.idRol;
    rol.denominacion = rolSeleccionado.denominacion;
    body.roles.push(rol);

    this.userService.altaUsuario(body).subscribe(result => {
      Swal.fire({
        title: 'Correcto!',
        text: 'El usuario ha sido creado con exito',
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      }).then(respuesta => {
        this.router.navigate(["/gestion-usuarios"]);
      })
    }, (error) => {
      this.mensajeError = error;
      this.error = true;
      this.validaciones = false;
    });
  }
}
